"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulingColumnFullWidthProps = exports.HaulingColumnProps = void 0;
const constants_1 = require("utils/constants");
const HaulingColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '370',
        filter: 'text',
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'driver',
        title: 'Driver Name',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel',
        title: 'Vessel',
        width: '250',
        filterable: false,
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text',
    },
];
exports.HaulingColumnProps = HaulingColumnProps;
const HaulingColumnFullWidthProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'driver',
        title: 'Driver Name',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel',
        title: 'Vessel',
        width: 'auto',
        filterable: false,
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text',
    },
];
exports.HaulingColumnFullWidthProps = HaulingColumnFullWidthProps;
